import React from 'react';
import { formatMoney } from '../../slate/currency';

const Price = () => null;

const CartItem = ({ item, incrementQuantity, decrementQuantity }) => (
  <div className="cart-item">
    <div className="cart-item__img">
      <img src={item.image} />
    </div>
    <div className="cart-item__details">
      <span className="cart-item__details-row">
        {item.product_title}
      </span>
      <span className="cart-item__details-row">
        {item.variant_title}
      </span>
      
      <div className="cart-item__qty-form">
        <span className="cart-item__qty">{item.quantity}</span>
        <button className="cart-item__qty-btn" onClick={decrementQuantity}>-</button>
        <button className="cart-item__qty-btn" onClick={incrementQuantity}>+</button>
      </div>
    </div>

    <span className="cart-item__price">
      {formatMoney(item.quantity * item.price, window.theme.moneyFormat)}
    </span>
  </div>
);

export default CartItem;



// WEBPACK FOOTER //
// ./assets/scripts/components/Cart/CartItem.js